module.exports = __webpack_public_path__ + "static/tab-galery-a8cf85de7c1417134502c7034a4bfbbb.jpg";